//close open finished

const Env = {
  //false, "open", "complete", "post-event"
  register: 'post-event',
  schedule: true,
  mentor: 'finished',
  volunteer: 'open',
};

export default Env;
